import withScroll from '../hoc/withScroll'

export default withScroll({
  name: 'sticky-button',

  componentDidMount () {
  },

  onScroll ({ y }) {
    if (y > 150) {
      this.el.classList.add('is-closed')
    } else {
      this.el.classList.remove('is-closed')
    }
  },
})
